export { UserService } from 'sce-core';
// #TODO-LIBRARY UserService Used in 55 places in 55 files WMS /src/app.. should be re-referenced from library directly



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/1_SCE_CI_CD_SIT/src/app/core/security/user.service.ts